import { render, staticRenderFns } from "./AgentManagementList.vue?vue&type=template&id=130fee4a&scoped=true"
import script from "./AgentManagementList.vue?vue&type=script&lang=js"
export * from "./AgentManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130fee4a",
  null
  
)

export default component.exports